import React, { useEffect, useState } from "react";

import { SubmitButton, Button } from "@culturehq/components";

import { useProfile } from "app/context";
import { useIsLoggedIn } from "app/hooks";
import { Trans, isTarget, t } from "app/utils";

import { ApprovedForSocial, Story } from "chq";
import SlackChannelField from "components/event/edit/SlackChannelField";
import ApproveForJobMappingButton from "components/admin/settings/stories/ApproveForJobMappingButton";
import { usePostStoryContext } from "../../contexts/PostStoryContext";

const PostStoryFooter = () => {
  const { profile } = useProfile();
  const isLoggedIn = useIsLoggedIn();
  const {
    organization,
    isCrossTenant,
    state: {
      postingStory, currentStory: story,
      mappersValueIds, selectedPrompt,
      userSelectedImage
    },
    setState,
    handleSelectedChannel,
    handleSubmit,
    handleSelectedJobMappings
  } = usePostStoryContext();

  const handleNext = () => setState({ userInformationRequest: true });
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    if (userSelectedImage && selectedPrompt) {
      setIsButtonDisabled(false);
    }
  }, [userSelectedImage, selectedPrompt]);

  const onClickSelectedMedia = () => {
    if (!userSelectedImage) {
      switch (selectedPrompt?.allowedTypes) {
        case "just_videos":
          setState({ error: t("Please select a video to share") });
          break;
        case "just_images":
          setState({ error: t("Please select an image to share") });
          break;
        default:
          setState({ error: t("Please select an image or video to share") });
          break;
      }
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
      handleNext();
    }
  };

  return (
    <div className="chq-pan--ft">
      <div className="Footer-Buttons">
        {isLoggedIn && !isTarget(organization?.name) && (
          <ApproveForJobMappingButton
            mappersValueIds={mappersValueIds}
            story={story}
            storyQuestion={story ? undefined : selectedPrompt}
            onUpdate={(value: Record<string, string[]> | Story | ApprovedForSocial) => {
              handleSelectedJobMappings(value as Record<string, string[]>);
            }}
          />
        )}
        {isLoggedIn && (
          <SlackChannelField
            className="modal-footer-column"
            disabled={!!story}
            imageIconPath="/slack.png"
            showLabel={false}
            onSelectedChannel={handleSelectedChannel}
            channel={story?.slackChannel}
            page="stories"
          />
        )}
        {isLoggedIn ? (
          <SubmitButton
            className="PostBtn"
            primary
            disabled={postingStory}
            onClick={
              isCrossTenant
                ? () => handleSubmit({ newPublicUser: { email: profile.email } })
                : handleSubmit
            }
          >
            {submitting => (submitting || postingStory ? (
              <Trans>Posting...</Trans>
            ) : (
              <Trans>{story?.id ? "Save" : "Post"} Story</Trans>
            ))}
          </SubmitButton>
        ) : (
          <Button
            aria-label={t("Next to fill your user information")}
            className="NextButton"
            primary
            disabled={isButtonDisabled}
            onClick={onClickSelectedMedia}
          >
            <Trans>Next</Trans>
          </Button>
        )}
      </div>
    </div>
  );
};

export default PostStoryFooter;
